<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-08-19 16:03:52
 * @最后编辑: Betway
 * @最后修改时间: 2023-06-08 10:57:08
-->
<template>
  <span>
    <v-btn
      rounded
      @click="dialogClick"
      height="40"
      color="primary"
      depressed
      class="text-button"
      dark
    >
      {{ label }}
    </v-btn>
    <mrc_ess_myDialog
      v-model="dialog"
      @flag="flag"
      :noPadding="false"
      :title="$t('label_Upload_CVS')"
      width="847"
      :disabled="false"
    >
      <mrc_ess_myStep :list="stepList" class="bigBoxBox" v-model="stepIndex">
        <template v-slot:1>
          <span
            class="d-flex ml-8 mt-8"
            style="color: rgb(164, 164, 164); font-size: 14px"
          >
            {{ $t("label_file") }}
          </span>
          <mrc_ess_importFile
            class="mr-8 ml-8 mb-8"
            ref="importFile"
            :hrefUrl="hrefUrl"
            v-model="file"
          ></mrc_ess_importFile>
          <mrc_ess_submitBtn
            @success="changeIndex(1)"
            :successText="$t('label_The_next_step')"
            @cancel="changeIndex(0)"
          ></mrc_ess_submitBtn>
        </template>
        <template v-slot:2>
          <div v-if="!uploadLoading">
            <div
              v-if="resStatus"
              class="pr-8 pl-8 d-flex"
              style="
                min-height: 350px;
                width: 100%;
                justify-content: center;
                align-items: center;
                font-size: 20px;
              "
            >
              <span>{{ $t("label_imported_successfully") }}!</span>
            </div>
            <div v-else>
              <div
                class="pr-8 pl-8 d-flex"
                v-if="!tableStatus"
                style="
                  min-height: 350px;
                  width: 100%;
                  justify-content: center;
                  align-items: center;
                  font-size: 20px;
                "
              >
                <div style="margin: 0 auto">
                  <div class="text-center">{{ $t("label_import_failed") }}!</div>
                  <div
                    @click="downloadError"
                    :style="{
                      color: $vuetify.theme.defaults.light.primary,
                      'text-decoration': 'underline',
                    }"
                  >
                    {{ $t("label_download_error_message") }}
                  </div>
                </div>
              </div>
              <!--错误信息 ----------- -->
              <div v-if="tableStatus" class="pr-8 pl-8">
                <!-- <slot name='table'></slot> -->
                <v-data-table
                  :headers="headers"
                  :isLoading="loading"
                  hide-default-footer
                  :items="desserts"
                >
                  <template v-slot:footer>
                    <mrc_ess_paginationsWeb
                      :options="options"
                      @setPerPage="setPerPage"
                      @change="turnPage"
                    ></mrc_ess_paginationsWeb>
                  </template>
                  <template v-slot:no-data>
                    <mrc_ess_noContent :no_data_text="$t('label_blank')" />
                  </template>
                </v-data-table>
              </div>
              <!-- ------- -->
            </div>
            <mrc_ess_submitBtn
              v-if="resStatus"
              :successText="$t('label_Complete')"
              @success="changeIndex(2)"
              :cancelShow="false"
            ></mrc_ess_submitBtn>
            <mrc_ess_submitBtn
              v-if="!resStatus && !tableStatus"
              :successText="$t('label_view_error_message')"
              :cancelText="$t('label_shut_down')"
              @success="changeIndex(4)"
              @cancel="changeIndex(3)"
            ></mrc_ess_submitBtn>
            <mrc_ess_submitBtn
              v-if="!resStatus && tableStatus"
              :successText="$t('label_download_error_message')"
              :cancelText="$t('label_shut_down')"
              @success="changeIndex(5)"
              @cancel="changeIndex(3)"
            ></mrc_ess_submitBtn>
          </div>
          <div
            v-else
            class="d-flex"
            style="
              min-height: 350px;
              width: 100%;
              justify-content: center;
              align-items: center;
            "
          >
            <svg id="load" x="0px" y="0px" viewBox="0 0 150 150">
              <circle id="loading-inner" cx="75" cy="75" r="60" />
            </svg>
          </div>
        </template>
      </mrc_ess_myStep>
    </mrc_ess_myDialog>
  </span>
</template>

<script>
/**
 * @findError  查询信息  接受函数   this.fn = getStaffLeaveList
 * @sendRequest 上传请求 发送请求到后端
 * @downloadError 下载错误信息
 */
import Cookie from "js-cookie";
import {
  uploadFileAll,
  uploadFileUser,
  uploadFileOrg,
  uploadError,
  uploadFilePostGrade,
  uploadFilePost,
  uploadFileCostCenter,
  uploadStaffGradeAndStaffType,
  uploadStaffRelationConfig,
  uploadStaffProperty,
  uploadOnBehalfApplicationConfig,
} from "@/service/api/upload.js";
import { refreshToken } from "@/service/httpConfig.js";
export default {
  components: {},
  props: {
    label: {
      type: String,
    },
    hrefUrl: {
      //下载模板的地址
      type: String,
    },
    // resStatus: { //请求完成之后的状态
    //   type: Boolean,
    // },
    // uploadLoading: { //请求加载状态
    //   type: Boolean,
    //   default: true
    // },
    type: {
      //上传接口类型  现在是三种 通用导入0  用户信息导入1  组织机构导入2
      type: String,
    },
    table: {
      type: String,
    },
  },
  data() {
    return {
      options: {},
      arr: [],
      errorObj: {},
      resStatus: false, //请求完成之后的状态
      uploadLoading: false, //请求加载状态
      desserts: [],
      dialog: false, //弹窗
      loading: false, //table加载状态
      stepIndex: 1,
      file: null,
      tableStatus: false, //表格显示,
    };
  },
  computed: {
    stepList() {
      return [
        {
          name: this.$t("label_Importing_files"),
        },
        {
          name: this.$t("label_result"),
        },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("存储格"),
          align: "start",
          value: "columns",
          sortable: false,
        },
        { text: this.$t("label_content"), value: "content", sortable: false },
        {
          text: this.$t("label_wrong_reason"),
          value: "error",
          sortable: false,
        },
      ];
    },
  },
  created() {},
  watch: {},
  mounted() {},
  methods: {
    dialogClick() {
      this.dialog = true;
      this.$refs.importFile ? this.$refs.importFile.deleteicon() : "";
    },
    async changeIndex(v) {
      // console.log("下一步下一步")
      // await refreshToken();
      if (v == 0) {
        this.dialog = false;
      } else if (v == 1) {
        //下一步 上传文件至后端
        if (this.file) {
          this.uploadLoading = true;
          this.stepIndex = 2;
          this.$emit("sendRequest", this.file);
          let formData = new FormData();
          let login_url = window.location.origin + "/#" + "/login";
          formData.append("attachment_file", this.file);
          formData.append(
            "formData",
            JSON.stringify({
              module_uuid: this.$store.state.menuFunctionUuid,
              "~table~": this.table ? this.table : "mrbase_sys_staffs",
              token: this.$ls.get("token"),
              login_url: login_url,
            })
          );
          console.log(formData);
          let response = null;
          if (this.type == 0) {
            //通用导入 国际化导入
            // console.log(formData.getAll('attachment_file'));
            await uploadFileAll(formData)
              .then((res) => {
                response = res;
              })
              .catch((err) => {
                this.$Message({
                  text: this.$t(err),
                  color: "rgba(0,0,0,0.78)",
                });
              });
          }
          if (this.type == 1) {
            //用户信息导入1
            await uploadFileUser(formData)
              .then((res) => {
                response = res;
              })
              .catch((err) => {
                this.$Message({
                  text: this.$t(err),
                  color: "rgba(0,0,0,0.78)",
                });
              });
          }
          if (this.type == 2) {
            //组织机构导入2
            await uploadFileOrg(formData)
              .then((res) => {
                response = res;
              })
              .catch((err) => {
                this.$Message({
                  text: this.$t(err),
                  color: "rgba(0,0,0,0.78)",
                });
              });
          }
          if (this.type == 3) {
            //岗位等级导入3
            await uploadFilePostGrade(formData)
              .then((res) => {
                response = res;
              })
              .catch((err) => {
                this.$Message({
                  text: this.$t(err),
                  color: "rgba(0,0,0,0.78)",
                });
              });
          }
          if (this.type == 4) {
            //岗位导入4
            await uploadFilePost(formData)
              .then((res) => {
                response = res;
              })
              .catch((err) => {
                this.$Message({
                  text: this.$t(err),
                  color: "rgba(0,0,0,0.78)",
                });
              });
          }
          if (this.type == 5) {
            //成本中心导入5
            await uploadFileCostCenter(formData)
              .then((res) => {
                response = res;
              })
              .catch((err) => {
                this.$Message({
                  text: this.$t(err),
                  color: "rgba(0,0,0,0.78)",
                });
              });
          }
          if (this.type == 6) {
            //员工等级和员工类型和员工关系导入
            await uploadStaffGradeAndStaffType(formData)
              .then((res) => {
                response = res;
              })
              .catch((err) => {
                this.$Message({
                  text: this.$t(err),
                  color: "rgba(0,0,0,0.78)",
                });
              });
          }
          if (this.type == 7) {
            //员工关系配置导入
            await uploadStaffRelationConfig(formData)
              .then((res) => {
                response = res;
              })
              .catch((err) => {
                this.$Message({
                  text: this.$t(err),
                  color: "rgba(0,0,0,0.78)",
                });
              });
          }
          if (this.type == 8) {
            //员工关系配置导入
            await uploadStaffProperty(formData)
              .then((res) => {
                response = res;
              })
              .catch((err) => {
                this.$Message({
                  text: this.$t(err),
                  color: "rgba(0,0,0,0.78)",
                });
              });
          }
          if (this.type == 9) {
            //代理申请配置导入
            await uploadOnBehalfApplicationConfig(formData)
              .then((res) => {
                response = res;
              })
              .catch((err) => {
                this.$Message({
                  text: this.$t(err),
                  color: "rgba(0,0,0,0.78)",
                });
              });
          }

          if (!response) this.$Message({ text: this.$t("导入文件失败") });
          if (response.code == 200) {
            this.uploadLoading = false;
            this.resStatus = true;
          } else if (response.code == "010") {
            this.uploadLoading = false;
            this.resStatus = false;
            // console.log(response.data)
            response.data ? (this.errorObj = this.$clone(response.data)) : "";
            for (let key in response.data) {
              let obj = {};
              let arr = response.data[key].split("<error>");
              obj["columns"] = arr[0];
              obj["content"] = arr[1];
              obj["error"] = arr[2];
              this.arr.push(obj);
            }
          } else {
            // this.dialog = false
            // this.uploadLoading = false
            this.flag();
          }
        } else {
          this.$Message({
            text: this.$t("message_please_add_upload_file"),
            color: "rgba(0,0,0,0.78)",
          });
        }
      } else if (v == 2) {
        //导入成功 关闭页面
        this.flag();
      } else if (v == 3) {
        //导入失败 关闭页面
        this.flag();
      } else if (v == 4) {
        //导入失败  查看错误信息列表
        this.findError();
      } else if (v == 5) {
        //导入失败  下载错误信息
        this.downloadError();
      }
    },
    setPerPage(val, val2) {
      //改变每页条数
      this.options = {
        cpage: 1,
        selectlist: [4, 7, 10],
        pagesize: val,
        totalcount: this.arr.length, //总条数
        totalpage: Math.ceil(this.arr.length / val),
      };
      let firstIndex = this.options.cpage * this.options.pagesize - this.options.pagesize;
      this.desserts = this.arr.slice(firstIndex).slice(0, this.options.pagesize);
    },
    turnPage(val, val2) {
      //点击页码
      this.options = {
        cpage: val,
        selectlist: [4, 7, 10],
        pagesize: val2.pagesize,
        totalcount: this.arr.length, //总条数
        totalpage: Math.ceil(this.arr.length / this.options.pagesize),
      };
      let firstIndex = this.options.cpage * this.options.pagesize - this.options.pagesize;
      this.desserts = this.arr.slice(firstIndex).slice(0, this.options.pagesize);
    },
    flag() {
      this.dialog = false;
      this.arr = [];
      this.tableStatus = false;
      if (this.stepIndex == 2) {
        this.stepIndex = 1;
      }
    },
    findError() {
      //查看错误
      this.tableStatus = true;
      this.options.selectlist = [4, 7, 10];
      this.options.pagesize = 5;
      this.options.cpage = 1;
      this.options.totalcount = this.arr.length; //总条数
      this.options.totalpage = Math.ceil(this.arr.length / this.options.pagesize); //总页数
      let firstIndex = this.options.cpage * this.options.pagesize - this.options.pagesize;
      this.desserts = this.arr.slice(firstIndex).slice(0, this.options.pagesize);
    },
    async downloadError() {
      //下载错误信息
      // uploadError(this.errorObj)
      //   .then(res => {
      //     const link = document.createElement('a');
      //     let blob = new Blob([res], { type: 'application/vnd.ms-excel' });
      //     link.style.display = 'none';
      //     //设置连接
      //     link.href = URL.createObjectURL(blob);
      //     link.download = 'error_message';
      //     document.body.appendChild(link);
      //     //模拟点击事件
      //     link.click();
      //     document.body.removeChild(link)
      //   })
      //   .catch(err => {
      //     this.$Message({ text: this.$t('下载失败') })
      //   })
      const res = await uploadError(this.errorObj);
      const link = document.createElement("a");
      let blob = new Blob([res], { type: "application/vnd.ms-excel" });
      link.style.display = "none";
      //设置连接
      link.href = URL.createObjectURL(blob);
      link.download = "error_message";
      document.body.appendChild(link);
      //模拟点击事件
      link.click();
      document.body.removeChild(link);
      this.flag();
    },
  },
};
</script>

<style lang="scss" scoped>
.bigBoxBox ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 8px 16px;
}

.bigBoxBox ::v-deep .v-stepper__header {
  background-color: #ffffff;
}

.load-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  height: 150px;
}

#load {
  width: 75px;
  animation: loading 3s linear infinite;

  #loading-inner {
    stroke: {
      dashoffset: 0;
      dasharray: 300;
      width: 10;
      miterlimit: 10;
      linecap: round;
    }

    animation: loading-circle 2s linear infinite;
    stroke: #0f46c1;
    fill: transparent;
  }
}

@keyframes loading {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes loading-circle {
  0% {
    stroke-dashoffset: 0;
  }

  100% {
    stroke-dashoffset: -600;
  }
}
</style>
